// Libs
import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Own Libs
import { Widget, Table, ColumnProps } from '@digital/ui';

//Api
import { ICrfRelatorioCicloOrcamentario } from '@app/api/crf/crfRelatorioCicloOrcamentario';

//Files

//Utils
import { valorReal, valorRealServidor } from '@app/helpers/comparators';

interface IGraficoCurvaProps {
  relatorio: ICrfRelatorioCicloOrcamentario;
  carregarTabela: boolean;
}
const GraficoCurva = ({ relatorio, carregarTabela }: IGraficoCurvaProps) => {
  if (relatorio) {
    if (relatorio.resultTable) {

      relatorio.resultTable.forEach((tabela: any) => {
        for (var t in tabela) {
          if (tabela[t] === valorReal || tabela[t] === valorRealServidor) {
            tabela[t] = null;
          }
        }
      })
    }
    if (relatorio.series) {
      relatorio.series.forEach((serie: any) => {
        for (var i = 0; i <= 11; i++) {
          if (serie.data[i] <= 0) {
            serie.data[i] = null;
          }
        }
      })
    }

  }

  const optionsColumn = useMemo(() => {

    if (relatorio) {

      const column: Highcharts.Options = {
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: relatorio.title
        },
        colors: ['#08340D', '#80BDA6', '#E1865C'],
        xAxis: {
          categories: relatorio.categories,
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          title: {
            text: 'Meses',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          }
        },
        yAxis: [
          {
            title: {
              text: 'Valor Acumulado',
              style: {
                color: Highcharts.getOptions().colors[0]
              }
            },
            labels: {
              formatter: function () { return '' + this.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ''; },
              style: {
                color: Highcharts.getOptions().colors[0]
              }
            },
            opposite: true
          },
          {
            labels: {
              formatter: function () { return '' + this.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ''; },
              style: {
                color: Highcharts.getOptions().colors[1]
              }
            },
            title: {
              text: 'Valor Mensal',
              style: {
                color: Highcharts.getOptions().colors[1]
              }
            }
          }
        ],
        tooltip: {
          formatter: function () { return '<b>' + this.y.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</b>'; }
        },

        labels: {
          items: [
            {
              style: {
                left: '15px',
                top: '18px',
                color:
                  // theme
                  (Highcharts.defaultOptions.title.style && Highcharts.defaultOptions.title.style.color) ||
                  'black',
              },
            },
          ],
        },
        series: relatorio.series,
      };
      return column;
    }

    const optionNull: Highcharts.Options = {};
    return optionNull;
  }, [relatorio]);

  const colluns = useMemo(() => {
    const colunas: ColumnProps<any>[] = [];
    if (relatorio && relatorio.colluns && relatorio.colluns.length > 0) {
      relatorio.colluns.forEach(colluns => {
        colunas.push({
          title: colluns.title,
          dataIndex: colluns.dataIndex,
          align: 'center',
        });
      });
    }
    return colunas;
  }, [relatorio]);

  return (
    <>
      {optionsColumn ?
        <HighchartsReact highcharts={Highcharts} options={optionsColumn} /> : <> </>
      }
      {relatorio && carregarTabela === true ? (
        <Widget>
          <Table
            columns={colluns}
            dataSource={relatorio.resultTable}
            rowKey={'id'}
            pagination={false} />
        </Widget>
      ) : (
        <> </>
      )}

    </>
  );

};

export default GraficoCurva;
